const cookieKeys = {
    loggedInNamespace: 'loggedInNamespace',
    originURL: 'originURL'
};

export default cookieKeys;
